import { useMemo } from 'react';
import { CustomPageType } from '../../extViewmodels/sdk/models/CustomPageStyle';
import { htmlHasCustomButtonColors } from '../../web/styles/customPageTheme';
import { useCustomPageStyleByShortCode } from '../queries/useCustomPageStyleByShortCode';
import { isInIframe } from '../utils/iframe';

export const useCustomPageStyle = (shortCode?: string, type: CustomPageType = CustomPageType.Header) => {
	const inIframe = isInIframe();

	const { data } = useCustomPageStyleByShortCode({
		shortCode,
		type,
		enabled: !!shortCode && !inIframe,
	});

	const hasCustomContent = !inIframe && !!data?.html;
	const hasCustomButtonColors = useMemo(
		() => hasCustomContent && htmlHasCustomButtonColors(data?.html),
		[hasCustomContent, data?.html]
	);

	return {
		data,
		hasCustomButtonColors,
		hasCustomContent,
		inIframe,
	};
};
